export default __webpack_public_path__ + "static/media/wallwrapcopy.421b2561.jpg";